module.exports = __webpack_public_path__ + "img/icons B_7.5c644751.png";